var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getDataGridLocaleText } from '../../../../application/common/constants/get-data-grid-locale-text';
import { Box, useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
var FeedbackDataGrid = function (_a) {
    var rows = _a.rows, columns = _a.columns, rowCount = _a.rowCount, paginationModel = _a.paginationModel, onPaginationModelChange = _a.onPaginationModelChange, filterModel = _a.filterModel, onFilterModelChange = _a.onFilterModelChange, onSortModelChange = _a.onSortModelChange, onRowClick = _a.onRowClick;
    var isScreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var isScreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    return (_jsx(Box, { padding: '16px', minHeight: 400, width: '100%', sx: {
            p: { xs: 0.5, md: 2 },
            backgroundColor: 'white',
            borderRadius: '16px',
            boxShadow: '0 24px 48px 0 #919EAB29',
            height: __assign(__assign({ sm: 'calc(100svh - 220px)' }, (isScreen600900 && { sm: 'calc(100svh - 300px)' })), (isScreen9001200 && { sm: 'calc(100svh - 300px)' }))
        }, children: _jsx(DataGrid, { localeText: getDataGridLocaleText(), onRowClick: function (params) { return onRowClick(params.row); }, getRowId: function (row) { return row.conversationId; }, getRowHeight: function () { return 'auto'; }, rowCount: rowCount, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, paginationMode: 'server', pageSizeOptions: [10, 20, 50, 100], filterMode: 'server', filterDebounceMs: 500, filterModel: filterModel, onFilterModelChange: onFilterModelChange, sortingMode: 'server', onSortModelChange: onSortModelChange, disableColumnSelector: true, disableRowSelectionOnClick: true, disableColumnResize: true, slotProps: {
                filterPanel: {
                    filterFormProps: {
                        operatorInputProps: {
                            variant: 'standard'
                        },
                        columnInputProps: {
                            variant: 'standard'
                        },
                        valueInputProps: {
                            InputComponentProps: {
                                variant: 'standard'
                            }
                        }
                    }
                }
            }, sx: {
                overflow: 'auto',
                borderWidth: '0px',
                backgroundColor: 'transparent',
                outline: 'none',
                '& .MuiDataGrid-row': {
                    cursor: 'pointer',
                    paddingTop: '8px',
                    paddingBottom: '8px'
                },
                '&, [class^=MuiDataGrid]': { border: 'none' },
                '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitleContainer': {
                    backgroundColor: '#F4F6F8 !important',
                    border: 'none'
                },
                '& .MuiDataGrid-selectedRowCount': {
                    display: 'none'
                },
                height: '100%'
            }, rows: rows, columns: columns }) }));
};
export default FeedbackDataGrid;
